/* GoGrowth: same-day delivery countdown (snippets/gg-delivery-promise.liquid).
   Time is always computed in IST (UTC+5:30, no DST), whatever the visitor's timezone. */
(function () {
  if (window.__ggSddLoaded) return;
  window.__ggSddLoaded = true;

  var IST_OFFSET_MS = 330 * 60 * 1000;

  function secondsIntoIstDay() {
    var ist = new Date(Date.now() + IST_OFFSET_MS);
    return ist.getUTCHours() * 3600 + ist.getUTCMinutes() * 60 + ist.getUTCSeconds();
  }

  function formatLeft(total) {
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    if (h > 0) return h + 'h ' + m + 'm';
    if (m === 0) return s + 's';
    return m + 'm ' + (s < 10 ? '0' : '') + s + 's';
  }

  // ---- PIN checker (only placements rendered with data-gg-pin-wrap) ----
  var PIN_KEY = 'gg_sdd_pin';

  function getPin() {
    try { return localStorage.getItem(PIN_KEY) || ''; } catch (e) { return ''; }
  }

  function setPin(pin) {
    try {
      if (pin) localStorage.setItem(PIN_KEY, pin);
      else localStorage.removeItem(PIN_KEY);
    } catch (e) {}
  }

  // data-pins: comma-separated PINs and ranges, e.g. "110001-110097,201301".
  function pinEligible(pin, wrap) {
    var list = wrap.__ggPins;
    if (!list) {
      list = (wrap.getAttribute('data-pins') || '').split(',').map(function (part) {
        var b = part.split('-');
        var lo = parseInt(b[0], 10);
        var hi = b.length > 1 ? parseInt(b[1], 10) : lo;
        return [lo, hi];
      }).filter(function (r) { return !isNaN(r[0]) && !isNaN(r[1]); });
      wrap.__ggPins = list;
    }
    var n = parseInt(pin, 10);
    for (var i = 0; i < list.length; i++) {
      if (n >= list[i][0] && n <= list[i][1]) return true;
    }
    return false;
  }

  function syncPinUi(wrap) {
    var pin = getPin();
    var editing = wrap.hasAttribute('data-editing') || !pin;
    var edit = wrap.querySelector('[data-gg-pin-edit]');
    var saved = wrap.querySelector('[data-gg-pin-saved]');
    if (edit) edit.hidden = !editing;
    if (saved) saved.hidden = editing;
    var value = wrap.querySelector('[data-gg-pin-value]');
    if (value && value.textContent !== pin) value.textContent = pin;
  }

  function checkPin(wrap) {
    var input = wrap.querySelector('[data-gg-pin-input]');
    var error = wrap.querySelector('[data-gg-pin-error]');
    var pin = (input && input.value || '').replace(/\D/g, '');
    if (!/^[1-9][0-9]{5}$/.test(pin)) {
      if (error) error.hidden = false;
      if (input) input.focus();
      return;
    }
    if (error) error.hidden = true;
    setPin(pin);
    wrap.removeAttribute('data-editing');
    tick();
  }

  function render(el, now) {
    var textEl = el.querySelector('[data-gg-sdd-text]');
    if (!textEl) return;
    var cutoff = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    if (isNaN(cutoff)) cutoff = 16;
    var left = cutoff * 3600 - now;

    var before = el.getAttribute('data-text-before') || '';
    var after = el.getAttribute('data-text-after') || '';
    var wrap = el.closest('[data-gg-pin-wrap]');
    var pin = wrap ? getPin() : '';
    var mode = '';
    if (pin) {
      if (pinEligible(pin, wrap)) {
        mode = 'ok';
        before = wrap.getAttribute('data-text-ok-before') || before;
        after = wrap.getAttribute('data-text-ok-after') || after;
      } else {
        mode = 'no';
        before = after = wrap.getAttribute('data-text-no') || after;
      }
      before = before.split('[pin]').join(pin);
      after = after.split('[pin]').join(pin);
    }
    if (el.getAttribute('data-pin-state') !== mode) el.setAttribute('data-pin-state', mode);

    if (left > 0 && before.indexOf('[time]') !== -1) {
      var key = 'before:' + before;
      var parts = before.split('[time]');
      var time = formatLeft(left);
      if (el.getAttribute('data-state') !== key || textEl.childNodes.length !== 3) {
        textEl.textContent = '';
        textEl.appendChild(document.createTextNode(parts[0] || ''));
        var strong = document.createElement('strong');
        strong.className = 'gg-sdd__time';
        textEl.appendChild(strong);
        textEl.appendChild(document.createTextNode(parts.slice(1).join('[time]')));
        el.setAttribute('data-state', key);
      }
      if (textEl.childNodes[1].textContent !== time) textEl.childNodes[1].textContent = time;
    } else {
      var text = left > 0 ? before : after;
      if (el.getAttribute('data-state') !== 'static:' + text) {
        textEl.textContent = text;
        el.setAttribute('data-state', 'static:' + text);
      }
    }
  }

  // The storefront cart drawer is the Corner (Cowi) app, not the theme drawer.
  // Mirror the theme drawer message above Corner's summary card; Corner re-renders
  // its DOM, so this re-checks on every tick and shortly after any click.
  function mountCorner() {
    var card = document.getElementById('corner-cowi-cart-summary-card');
    if (!card || !card.parentNode) return;
    if (card.previousElementSibling && card.previousElementSibling.hasAttribute('data-gg-sdd-corner')) return;
    var src = document.querySelector('.gg-sdd-wrap--drawer') || document.querySelector('.gg-sdd--drawer');
    if (!src) return;
    var clone = src.cloneNode(true);
    clone.setAttribute('data-gg-sdd-corner', '');
    clone.classList.add('gg-sdd-wrap--corner');
    var msg = clone.matches('[data-gg-sdd]') ? clone : clone.querySelector('[data-gg-sdd]');
    if (msg) {
      msg.removeAttribute('data-state');
      msg.classList.add('gg-sdd--corner');
    }
    card.parentNode.insertBefore(clone, card);
    tick();
  }

  function tick() {
    mountCorner();
    var now = secondsIntoIstDay();
    var els = document.querySelectorAll('[data-gg-sdd]');
    for (var i = 0; i < els.length; i++) render(els[i], now);
    var wraps = document.querySelectorAll('[data-gg-pin-wrap]');
    for (var j = 0; j < wraps.length; j++) syncPinUi(wraps[j]);
  }

  function start() {
    tick();
    // Align to the next full second so every placement changes together.
    setTimeout(function () {
      tick();
      setInterval(tick, 1000);
    }, 1000 - (Date.now() % 1000));
    document.addEventListener('click', function () {
      setTimeout(mountCorner, 60);
      setTimeout(mountCorner, 400);
    }, true);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      var wrap = t.closest('[data-gg-pin-wrap]');
      if (!wrap) return;
      if (t.closest('[data-gg-pin-check]')) {
        e.preventDefault();
        checkPin(wrap);
      } else if (t.closest('[data-gg-pin-change]')) {
        e.preventDefault();
        wrap.setAttribute('data-editing', '');
        var input = wrap.querySelector('[data-gg-pin-input]');
        syncPinUi(wrap);
        if (input) {
          input.value = getPin();
          input.focus();
          input.select();
        }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-gg-pin-input]')) return;
      e.preventDefault();
      checkPin(e.target.closest('[data-gg-pin-wrap]'));
    });
    document.addEventListener('input', function (e) {
      if (!e.target.matches || !e.target.matches('[data-gg-pin-input]')) return;
      var clean = e.target.value.replace(/\D/g, '').slice(0, 6);
      if (clean !== e.target.value) e.target.value = clean;
      var err = e.target.closest('[data-gg-pin-wrap]').querySelector('[data-gg-pin-error]');
      if (err) err.hidden = true;
    });
    window.addEventListener('storage', function (e) {
      if (e.key === PIN_KEY) tick();
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
